// 页面访问权限检查工具
// 统一管理需要自动退出的页面列表

/**
 * 检查当前页面是否需要自动退出登录
 * 只在特定页面（如列表页面）才执行自动退出
 * @param {string} pathname - 页面路径，默认为当前页面路径
 * @returns {boolean} 是否需要自动退出
 */
export const shouldAutoLogout = (pathname = window.location.pathname) => {
  // 只在以下页面执行自动退出登录
  const autoLogoutPages = [
    /^\/forms$/, // 表单列表页
    /^\/forms\/$/, // 表单列表页（带斜杠）
    /^\/account-settings/, // 账号设置页
    /^\/black-card-management/, // 黑卡管理页
    /^\/feedback-management/, // 反馈管理页
    /^\/webhook-chat/, // 话术生成页
    /^\/webhook-upload/, // 活动策划页
    /^\/ai-assistant/, // AI助手页
    /^\/material-library/, // 素材库页
    /^\/knowledge-base/, // 知识库页
    /^\/lottery/, // 抽奖页
    /^\/heartbeat-status/, // 心跳状态页
  ];
  
  return autoLogoutPages.some(reg => reg.test(pathname));
};

/**
 * 检查当前页面是否允许匿名访问
 * @param {string} pathname - 页面路径，默认为当前页面路径
 * @returns {boolean} 是否允许匿名访问
 */
export const isAnonymousPage = (pathname = window.location.pathname) => {
  const allowAnonymous = [
    /^\/login/,
    /^\/detail\//, // 表单填写页
    /^\/display\//, // 表单显示页
    /^\/wechat-auth/,
    /^\/wechat-callback/,
    /^\/wechat-bind-callback/
  ];
  
  return allowAnonymous.some(reg => reg.test(pathname));
};

/**
 * 检查当前页面是否需要登录
 * @param {string} pathname - 页面路径，默认为当前页面路径
 * @returns {boolean} 是否需要登录
 */
export const requiresLogin = (pathname = window.location.pathname) => {
  return !isAnonymousPage(pathname);
};

/**
 * 获取需要自动退出的页面列表
 * @returns {Array<RegExp>} 需要自动退出的页面正则表达式数组
 */
export const getAutoLogoutPages = () => {
  return [
    /^\/forms$/, // 表单列表页
    /^\/forms\/$/, // 表单列表页（带斜杠）
    /^\/account-settings/, // 账号设置页
    /^\/black-card-management/, // 黑卡管理页
    /^\/feedback-management/, // 反馈管理页
    /^\/webhook-chat/, // 话术生成页
    /^\/webhook-upload/, // 活动策划页
    /^\/ai-assistant/, // AI助手页
    /^\/material-library/, // 素材库页
    /^\/knowledge-base/, // 知识库页
    /^\/lottery/, // 抽奖页
    /^\/heartbeat-status/, // 心跳状态页
  ];
};

/**
 * 获取匿名访问白名单
 * @returns {Array<RegExp>} 匿名访问白名单正则表达式数组
 */
export const getAnonymousPages = () => {
  return [
    /^\/login/,
    /^\/detail\//, // 表单填写页
    /^\/display\//, // 表单显示页
    /^\/wechat-auth/,
    /^\/wechat-callback/,
    /^\/wechat-bind-callback/
  ];
};

export default {
  shouldAutoLogout,
  isAnonymousPage,
  requiresLogin,
  getAutoLogoutPages,
  getAnonymousPages
};
